module.exports = __webpack_public_path__ + "static/media/MHRP89N1000.d9148f05.svg";